<div
  fxLayout="column"
  fxLayoutAlign="space-between"
  class="properties-editor-form-container"
  [style.height]="propertiesExist ? '143px' : 'auto'"
>
  <table
    id="properties-form"
    tabContent=""
    style="width: 100%; max-width: 100%; table-layout: fixed; border-collapse: collapse"
  ></table>
</div>

@if (!propertiesExist) {
  <div class="noDataPropertiesPlaceHolder">
    {{ res('PropertiesEditor-NoProperties') }}
  </div>
}
@if (propertiesExist && showButton && !isReadOnly) {
  <div class="fab-container-properties">
    <button mat-fab class="fab-toggler" (click)="saveProperties()" [disabled]="!parentId">
      <i class="material-icons">save</i>
    </button>
  </div>
}
